export default __webpack_public_path__ + "static/media/kennedy.2e5eedf9.png";